// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".kong-icon[data-v-419e27ea]{display:inline-block}.kong-icon .slot-content[data-v-419e27ea],.kong-icon .svg-with-slot-is-hidden[data-v-419e27ea]{display:none!important;visibility:hidden!important}", ""]);
// Exports
module.exports = exports;
